module.exports = __webpack_public_path__ + "static/media/NSS.2122f752.jfif";